import Flex, { FlexProps, Gap } from './Flex';

export default Flex;
export type { FlexProps, Gap };
